import { create } from 'zustand';
import type { BusinessPlan, StageProgress } from '../types/businessPlan';
import type { StageName } from '../lib/collections';

interface PlanState {
  activePlan: BusinessPlan | null;
  stageData: Partial<Record<StageName, StageProgress>>;
  loading: boolean;

  setActivePlan: (plan: BusinessPlan | null) => void;
  setStageData: (data: Partial<Record<StageName, StageProgress>>) => void;
  setLoading: (loading: boolean) => void;
  reset: () => void;
}

export const usePlanStore = create<PlanState>((set) => ({
  activePlan: null,
  stageData: {},
  loading: false,

  setActivePlan: (plan) =>
    set({ activePlan: plan, stageData: plan?.stageProgress ?? {} }),
  setStageData: (data) => set({ stageData: data }),
  setLoading: (loading) => set({ loading }),
  reset: () => set({ activePlan: null, stageData: {}, loading: false }),
}));
